"use client";

import { usePathname } from "next/navigation";
import AppHeaderInner from "@/app/new-home/new-home-page/src/header/AppHeaderInner";
import HeaderAlert from "@/app/new-home/new-home-page/src/header/HeaderAlert";
import DeviceIdLogic from "components/layouts/Header/DeviceIdLogic";
import UsersCurrencyLogic from "components/layouts/Header/UsersCurrencyLogic";
const AppHeaderNewHome = () => {
  const pathname = usePathname();
  const isPaymentPage = pathname?.startsWith("/payment");
  const isVacationRentalPage = pathname?.startsWith("/vacation-rentals");
  const hideHeaderOnDesktop = isPaymentPage || isVacationRentalPage;
  return <>
      <HeaderAlert data-sentry-element="HeaderAlert" data-sentry-source-file="AppHeader.tsx" />
      <div className={`fixed left-0 right-0 top-0 ${hideHeaderOnDesktop ? "hidden md:block" : ""} z-[900] w-full bg-primary-500 text-white transition-colors duration-200`}>
        <AppHeaderInner data-sentry-element="AppHeaderInner" data-sentry-source-file="AppHeader.tsx" />
      </div>
      <div className={`${hideHeaderOnDesktop ? "hidden md:block" : ""} min-h-[60px] md:min-h-[80px]`}>
        {/* this is added to add space on top of content such that contant doesn't hide behind header */}
      </div>
      <DeviceIdLogic data-sentry-element="DeviceIdLogic" data-sentry-source-file="AppHeader.tsx" />
      <UsersCurrencyLogic data-sentry-element="UsersCurrencyLogic" data-sentry-source-file="AppHeader.tsx" />
    </>;
};
export default AppHeaderNewHome;